export interface ILoginPayload {
  email: string;
  password: string;
}

export interface ILoginResponse {
  accessToken: string;
  uaePass?: {
    linked: boolean;
    idToken?: string;
  };
}

export interface IUAEPassLoginResponse {
  authUrl: string;
  state: string;
}

export interface IUAEPassCallbackPayload {
  code: string;
  state: string;
}

export interface IVerifyEmailPayload {
  token: string;
}

export interface IVerifyEmailResponse {
  token: string;
}

export interface IMeInfo {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  createdAt: string;
  updatedAt: string;
}

export enum SignOutReason {
  USER_ACTION = 'userAction',
  SESSION_EXPIRED = 'sessionExpired',
}
